export const companyProfileQuery = `query getCompanyProfile ($vieweeCompanyId: ID!, $viewerCompanyId: ID!) {
      companyProfile  (id: $vieweeCompanyId) {
        companyName
        id
        companyId
        isMarketingReady
        name
        coverImageUrl
        marketSegments
        marketServed
        companyTypes
        website
        phone
        profileImageUrl
        quickResponder
        address {
          addressOne
          addressTwo
          city
          state
          country
          postalCode
          formattedAddress
        }
        destinationsSold
        connectionInfo (vieweeCompanyId: $vieweeCompanyId, viewerCompanyId: $viewerCompanyId) {
          id
          lastSent
          shouldShowContactInfo
          status
          isSender
        }
        corporateIdentifier
        type
        description
        contacts {
          firstName
          lastName
          name
          type
          phone
          fax
          email
        }
        groups {
          _id
          tag
          items
        }
        locations (viewerCompanyId: $viewerCompanyId) {
          name
          id
          city
          state
          country
          images
          isMarketingReady
          numOfProducts
        }
        companyBadges {
          membershipId
          verifiedStatus
          name
          badgeId
          logo
          companyBadgeId
          acronym
          website
        }
      }
    }`;



// WEBPACK FOOTER //
// ./src/app/stores/company/company/company-graphql-query.js